import { JSX } from 'react'

import s from './s.module.scss'

const AirdropFinished = (): JSX.Element => {
  return (
    <section className={s.finishedBlock}>
      <div className={s.finishedDescription}>Airdrop has been finished</div>
    </section>
  )
}

export default AirdropFinished
